import { useMemo } from 'react';
import { DateTime } from 'luxon';

import { InputOption } from 'components/forms/raw/SelectInput';
import TicketDto from 'types/api/TicketDto';
import UserDto from 'types/api/UserDto';
import TicketStatus from 'types/TicketStatus';

export interface TicketFormState {
  assignedTo: InputOption<number, UserDto>;
  dueDate: DateTime;
  ticketDescription: string;
  ticketStatus: TicketStatus;
  originalTicket: TicketDto;
}

const useInitialValues = (ticket: TicketDto): TicketFormState =>
  useMemo(
    () => ({
      assignedTo: {
        value: ticket.assigned_user.id,
        label: `${ticket.assigned_user.first_name} ${ticket.assigned_user.last_name}`,
        meta: ticket.assigned_user,
      },
      ticketDescription: ticket.short_description,
      dueDate: DateTime.fromISO(ticket.due_date),
      ticketStatus: ticket.ticket_status,
      originalTicket: ticket,
    }),
    [ticket],
  );

export default useInitialValues;
